import {
  Dashboard,
  OnCreateDashboardSubscription,
  OnUpdateDashboardSubscription,
  onCreateDashboard,
  onUpdateDashboard,
} from '@akin-home/amplify';
import { GraphQLSubscription } from '@aws-amplify/api';
import { API, graphqlOperation } from 'aws-amplify';
import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { dashboard_query_keys } from './query_keys';

interface Params {
  username: string;
}

export const useSubscribeToDashboards = ({ username }: Params) => {
  const query_client = useQueryClient();

  const update_sub = useRef<any>();
  const create_sub = useRef<any>();

  useEffect(() => {
    if (update_sub.current) {
      update_sub.current.unsubscribe();
    }

    if (create_sub.current) {
      create_sub.current.unsubscribe();
    }

    const vars = { owner: username };

    update_sub.current = API.graphql<
      GraphQLSubscription<OnUpdateDashboardSubscription>
    >(graphqlOperation(onUpdateDashboard, vars)).subscribe({
      next: ({ value: { data } }) => {
        const updated_dashboard = data?.onUpdateDashboard;

        if (!updated_dashboard) return;

        query_client.setQueriesData<Dashboard[]>(
          dashboard_query_keys.lists() as any,
          (data) =>
            data?.map((d) =>
              d.id === updated_dashboard.id ? updated_dashboard : d
            ) || []
        );
      },
      error(err) {
        console.log('Dashboard Update Sub Error', err);
      },
    });

    create_sub.current = API.graphql<
      GraphQLSubscription<OnCreateDashboardSubscription>
    >(graphqlOperation(onCreateDashboard, vars)).subscribe({
      next: () => query_client.invalidateQueries(dashboard_query_keys.lists()),
      error(err) {
        console.log('Dashboard Update Sub Error', err);
      },
    });

    // Stop receiving data updates from the subscription
    return () => {
      update_sub.current?.unsubscribe();
      create_sub.current?.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);
};
